module.exports = __webpack_public_path__ + "img/iconminicall.2a30f68e.png";